import mixpanel from "mixpanel-browser";
import { Config } from "../../Config";

let initialized = false;

/**
 * Product analytics and Session Replay are optional until a deployment supplies
 * VITE_MIXPANEL_TOKEN. Keeping the token optional prevents an unconfigured
 * environment from blocking the application.
 */
export const initializeMixpanel = () => {
  if (initialized || !Config.MIXPANEL_TOKEN) {
    return;
  }

  mixpanel.init(Config.MIXPANEL_TOKEN, {
    api_host: "https://api-eu.mixpanel.com",
    record_sessions_percent: 100,
    record_heatmap_data: true,
  });
  initialized = true;
};

export const identifyMixpanelUser = (userId: string) => {
  if (!initialized) {
    return;
  }

  mixpanel.identify(userId);
};

export const resetMixpanelUser = () => {
  if (!initialized) {
    return;
  }

  mixpanel.reset();
};
